import * as React from "react";

const SvgTranslate = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M3 5h12M9 3v2M10.048 14.5A18.022 18.022 0 0 1 6.412 9M12.5 18h7M11 21l5-10 5 10" />
      <path d="M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
    </g>
  </svg>
);

export default SvgTranslate;
